import * as ActionConfigurationManager from './config.actions';

export const checkActiveOrder = ActionConfigurationManager.CHECK_FOR_ACTIVE_ORDER;
export const checkActiveOrderFailed = ActionConfigurationManager.CHECK_FOR_ACTIVE_ORDER_FAILED;
export const checkActiveOrderSuccess = ActionConfigurationManager.CHECK_FOR_ACTIVE_ORDER_SUCCESS;
